'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.parseSassFile = exports.parseScssFile = undefined;
var _regenerator = require('babel-runtime/regenerator');
var _regenerator2 = _interopRequireDefault(_regenerator);
var _promise = require('babel-runtime/core-js/promise');
var _promise2 = _interopRequireDefault(_promise);
var _asyncToGenerator2 = require('babel-runtime/helpers/asyncToGenerator');
var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
var matchScssString = '@import\\s*[\'"`]([^\'"`]+)[\'"`]\\s*;';
var matchSassString = '@import\\s*[\'"`]?([^\'"`;]+)[\'"`]?\\s*;';
var getAllImports = function getAllImports(code, matchString) {
  var matcher = new RegExp(matchString);
  var matches = [];
  var m = matcher.exec(code);
  while (m) {
    if (m[1]) {
      matches.push(m[1]);
      code = code.slice(m.index + m[0].length);
      matcher = new RegExp(matchString);
      m = matcher.exec(code);
    }
  }
  return matches.map(function (match) {
    if (match[0] !== '.' && match[0] !== '/') return './' + match;
    return match;
  });
};
var parseScssFile = function () {
  var _ref = (0, _asyncToGenerator3.default)(/*#__PURE__*/_regenerator2.default.mark(function _callee(file) {
    var fileCode, internalImports;
    return _regenerator2.default.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            _context.next = 2;
            return _promise2.default.resolve(file);
          case 2:
            fileCode = _context.sent;
            internalImports = getAllImports(fileCode, matchScssString).map(function (a) {
              return a + '.scss';
            });
            return _context.abrupt('return', {
              file: fileCode,
              internalImports: internalImports,
              deps: {}
            });
          case 5:
          case 'end':
            return _context.stop();
        }
      }
    }, _callee, undefined);
  }));
  return function parseScssFile(_x) {
    return _ref.apply(this, arguments);
  };
}();
var parseSassFile = function () {
  var _ref2 = (0, _asyncToGenerator3.default)(/*#__PURE__*/_regenerator2.default.mark(function _callee2(file) {
    var fileCode, internalImports;
    return _regenerator2.default.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            _context2.next = 2;
            return _promise2.default.resolve(file);
          case 2:
            fileCode = _context2.sent;
            internalImports = getAllImports(fileCode, matchSassString).concat(getAllImports(fileCode, matchScssString)).map(function (a) {
              return a + '.sass';
            });
            return _context2.abrupt('return', {
              file: fileCode,
              internalImports: internalImports,
              deps: {}
            });
          case 5:
          case 'end':
            return _context2.stop();
        }
      }
    }, _callee2, undefined);
  }));
  return function parseSassFile(_x2) {
    return _ref2.apply(this, arguments);
  };
}();
exports.parseScssFile = parseScssFile;
exports.parseSassFile = parseSassFile;